module.exports = __webpack_public_path__ + "img/lab-room-one.3cbbfcfa.png";